var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('Can', {
    attrs: {
      "I": _vm.ActionEnum.CREATE,
      "a": _vm.ResourceEnum.TICKET,
      "field": _vm.partnerId
    }
  }, [!_vm.hideButton && !_vm.isIconButton ? _c('v-btn', {
    attrs: {
      "color": "info",
      "elevation": "0",
      "loading": _vm.isLoadingStartDialog,
      "small": _vm.smallBtn
    },
    domProps: {
      "textContent": _vm._s(_vm.$t('project.ticket.newTicket'))
    },
    on: {
      "click": _vm.startDialog
    }
  }) : _vm._e(), _vm._t("activator", function () {
    return [!_vm.hideButton && _vm.isIconButton ? _c('v-btn', {
      attrs: {
        "icon": ""
      },
      on: {
        "click": _vm.startDialog
      }
    }, [_c('v-icon', [_vm._v(" mdi-ticket-outline")])], 1) : _vm._e()];
  }, {
    "slotScope": {
      open: _vm.open
    }
  })], 2), _vm.dialogActive ? _c('confirm-action-dialog', {
    key: 'confirm-action-dialog' + _vm.dialogActive,
    attrs: {
      "width": "1050",
      "isDialogActive": _vm.dialogActive,
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "loading": _vm.isLoading,
      "title": _vm.$t('project.ticket.stepper.title.createTicket'),
      "supressKeyboardActions": true,
      "leftLoading": _vm.isLoading,
      "rightLoading": _vm.isLoading,
      "rightDisabled": !_vm.ticket.title,
      "leftText": _vm.$t('close'),
      "rightText": _vm.$t('create')
    },
    on: {
      "update:isDialogActive": function updateIsDialogActive($event) {
        _vm.dialogActive = $event;
      },
      "update:is-dialog-active": function updateIsDialogActive($event) {
        _vm.dialogActive = $event;
      },
      "leftClick": _vm.close,
      "rightClick": _vm.onCreateTicket,
      "close": _vm.close
    }
  }, [_c('v-form', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "7"
    }
  }, [_c('v-row', {
    staticClass: "mt-1",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "8"
    }
  }, [_c('v-text-field', {
    attrs: {
      "outlined": "",
      "required": "",
      "label": _vm.$t('project.ticket.title'),
      "rules": _vm.rules(_vm.RulesEnum.REQUIRED_RULE)
    },
    model: {
      value: _vm.ticket.title,
      callback: function callback($$v) {
        _vm.$set(_vm.ticket, "title", $$v);
      },
      expression: "ticket.title"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    staticClass: "mx-1",
    attrs: {
      "type": "date",
      "label": _vm.$t('project.ticket.due'),
      "outlined": "",
      "clearable": true
    },
    model: {
      value: _vm.ticket.dueDate,
      callback: function callback($$v) {
        _vm.$set(_vm.ticket, "dueDate", $$v);
      },
      expression: "ticket.dueDate"
    }
  })], 1), _vm.suggestions && _vm.suggestions.length ? _c('v-col', {
    staticClass: "mt-n7 pb-2",
    attrs: {
      "cols": "12"
    }
  }, _vm._l(_vm.suggestions, function (suggestion, index) {
    return _c('v-btn', {
      key: suggestion + index,
      attrs: {
        "text": "",
        "small": ""
      },
      on: {
        "click": function click($event) {
          _vm.ticket.title = "".concat(_vm.ticket.title, " ").concat(suggestion);
        }
      }
    }, [_c('i', [_c('small', {
      domProps: {
        "textContent": _vm._s(suggestion)
      }
    })])]);
  }), 1) : _vm._e()], 1), _c('template-editor', {
    attrs: {
      "height": "250px",
      "label": _vm.$t('project.ticket.description')
    },
    model: {
      value: _vm.ticket.body,
      callback: function callback($$v) {
        _vm.$set(_vm.ticket, "body", $$v);
      },
      expression: "ticket.body"
    }
  }), !_vm.hideProject && _vm.ticket && _vm.ticket.projectId && _vm.selectedProject ? _c('custom-field-list-form', {
    key: 'customFieldListFormKey' + _vm.ticket.projectId,
    attrs: {
      "customFieldConfig": _vm.selectedProject.configuration.customFieldConfig
    },
    model: {
      value: _vm.ticket.values,
      callback: function callback($$v) {
        _vm.$set(_vm.ticket, "values", $$v);
      },
      expression: "ticket.values"
    }
  }) : _vm._e()], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "5"
    }
  }, [_vm.canUpdateAppraisal ? _c('select-assignees', {
    attrs: {
      "dense": false,
      "outlined": true,
      "css": "width: 100%"
    },
    model: {
      value: _vm.ticket.assignees,
      callback: function callback($$v) {
        _vm.$set(_vm.ticket, "assignees", $$v);
      },
      expression: "ticket.assignees"
    }
  }) : _vm._e(), _c('Can', {
    attrs: {
      "I": _vm.ActionEnum.READ,
      "a": _vm.ResourceEnum.TAG,
      "field": _vm.partnerId
    }
  }, [_c('select-tags', {
    staticClass: "py-2",
    attrs: {
      "resource": _vm.ResourceEnum.TICKET,
      "partnerId": _vm.partnerId,
      "label": _vm.$t('project.ticket.tags')
    },
    model: {
      value: _vm.ticket.tags,
      callback: function callback($$v) {
        _vm.$set(_vm.ticket, "tags", $$v);
      },
      expression: "ticket.tags"
    }
  })], 1), _c('v-autocomplete', {
    attrs: {
      "loading": _vm.isLoadingProjects,
      "item-value": "id",
      "item-text": "title",
      "label": _vm.$t('project.ticket.project'),
      "items": _vm.projects,
      "outlined": "",
      "clearable": ""
    },
    scopedSlots: _vm._u([{
      key: "append",
      fn: function fn() {
        return [_c('project-create-dialog', {
          on: {
            "created": function created(project) {
              return _vm.ticket.projectId = project.id;
            }
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function fn(_ref) {
              var on = _ref.on;
              return [_c('v-btn', {
                staticStyle: {
                  "position": "relative",
                  "top": "-6px"
                },
                attrs: {
                  "icon": "",
                  "loading": _vm.isLoadingProjects
                },
                on: {
                  "click": function click($event) {
                    $event.stopPropagation();
                    return on.apply(null, arguments);
                  }
                }
              }, [_c('v-icon', [_vm._v("mdi-plus")])], 1)];
            }
          }], null, false, 8061768)
        })];
      },
      proxy: true
    }, {
      key: "selection",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v(" " + _vm._s(item.title) + " ")])], 1)];
      }
    }, {
      key: "item",
      fn: function fn(_ref3) {
        var item = _ref3.item;
        return [_c('v-list-item-content', {
          staticStyle: {
            "max-width": "400px"
          }
        }, [_c('v-list-item-title', [_vm._v(" " + _vm._s(item.title) + " ")]), _c('v-list-item-subtitle', [_vm._v(" " + _vm._s(item.description) + " ")])], 1)];
      }
    }], null, false, 2743110993),
    model: {
      value: _vm.ticket.projectId,
      callback: function callback($$v) {
        _vm.$set(_vm.ticket, "projectId", $$v);
      },
      expression: "ticket.projectId"
    }
  }), _c('div', {
    staticClass: "mt-n7",
    staticStyle: {
      "display": "flex"
    }
  }, [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "x-small": "",
      "text": "",
      "elevation": 0,
      "loading": _vm.isLoadingProjects
    },
    on: {
      "click": _vm.refreshProjects
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("common.verbs.refresh")) + " ")]), _c('v-btn', {
    attrs: {
      "x-small": "",
      "text": "",
      "elevation": 0
    },
    on: {
      "click": _vm.goToProject
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("common.verbs.view")) + " ")])], 1), _c('ticket-refs-select', {
    attrs: {
      "partnerId": _vm.partnerId,
      "listMode": true,
      "isConfirmable": false,
      "hideEditButton": true
    },
    model: {
      value: _vm.ticket.refs,
      callback: function callback($$v) {
        _vm.$set(_vm.ticket, "refs", $$v);
      },
      expression: "ticket.refs"
    }
  })], 1)], 1)], 1)], 1) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }